import { validAccountNumber } from '@eika-infrastruktur/format';

import TranslationsConfigType from '../../../../translations/translationType';

export interface ValidationMessage {
    accountNameInput?: string;
    accountNumberInput?: string;
}

export interface Props {
    accountNumber: string;
    accountName: string;
    translated: TranslationsConfigType;
    ocrName?: string;
    isInPaymentContext?: boolean;
    duplicateAccountWarning?: string;
}

const validateForm = ({
    accountNumber,
    accountName,
    translated,
    ocrName,
    isInPaymentContext = true,
    duplicateAccountWarning,
}: Props): ValidationMessage => {
    const result: ValidationMessage = {};
    if (!ocrName && !accountName) {
        result.accountNameInput = translated.paymentValidation.requiredField;
    }
    if (!accountNumber) {
        result.accountNumberInput = translated.paymentValidation.requiredField;
    }
    if (accountNumber && !validAccountNumber(accountNumber)) {
        result.accountNumberInput = translated.paymentValidation.invalidAccountNumber;
    }
    if (!isInPaymentContext && duplicateAccountWarning !== undefined) {
        result.accountNumberInput = duplicateAccountWarning;
    }
    return result;
};

export default validateForm;
